var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9604_12652)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9604_12652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 9C9.48179 9 10.4833 8.58516 11.2217 7.84673C11.9602 7.10831 12.375 6.10679 12.375 5.0625C12.375 4.01821 11.9602 3.01669 11.2217 2.27827C10.4833 1.53984 9.48179 1.125 8.4375 1.125C7.39321 1.125 6.39169 1.53984 5.65327 2.27827C4.91484 3.01669 4.5 4.01821 4.5 5.0625C4.5 6.10679 4.91484 7.10831 5.65327 7.84673C6.39169 8.58516 7.39321 9 8.4375 9ZM1.6875 12.0938V12.375C1.6875 13.7211 2.54419 14.8596 3.76031 15.6336C4.98319 16.4121 6.63863 16.875 8.4375 16.875C8.53762 16.875 8.63606 16.8682 8.73506 16.8654C8.73113 16.821 8.71875 16.7794 8.71875 16.7344V13.0894C8.71875 12.5724 8.94431 12.0842 9.33862 11.7501L11.25 10.125H3.65625C3.13411 10.125 2.63335 10.3324 2.26413 10.7016C1.89492 11.0708 1.6875 11.5716 1.6875 12.0938ZM12.627 10.062C12.7923 9.92151 13.0021 9.84436 13.219 9.84436C13.4359 9.84436 13.6458 9.92151 13.8111 10.062L16.5532 12.393C16.7574 12.5668 16.8756 12.8211 16.8756 13.0894V16.7344C16.8756 17.1225 16.5606 17.4375 16.1724 17.4375H15.0474C14.6593 17.4375 14.3443 17.1225 14.3443 16.7344V14.9062C14.3443 14.7575 14.2854 14.6147 14.1804 14.5093C14.0754 14.4039 13.9329 14.3443 13.7841 14.3438H12.654C12.5052 14.3443 12.3627 14.4039 12.2577 14.5093C12.1527 14.6147 12.0937 14.7575 12.0938 14.9062V16.7344C12.0938 17.1225 11.7788 17.4375 11.3906 17.4375H10.2656C9.8775 17.4375 9.5625 17.1225 9.5625 16.7344V13.0894C9.5625 12.8211 9.68006 12.5668 9.88481 12.393L12.627 10.062Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9604_12652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9604_12652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveIcon);
export default __webpack_public_path__ + "static/media/leaveIcon.bcf372a11b0348fd0e0a58b082eaac55.svg";
export { ForwardRef as ReactComponent };